import classNames from 'classnames';

import PermissionSection from 'components/permission/PermissionSection';
import { Permissions } from 'entities/dashboard';

interface OwnerRadioOption {
  value: number | boolean;
  name: string;
}

interface OwnerRadioProps {
  idPrefix: string;
  label: string;
  options: Array<OwnerRadioOption>;
  value: number | boolean | undefined;
  onChange: (value) => void;
  error?: any;
  disabled?: boolean;
  className?: string;
}

const OwnerRadio: React.FC<OwnerRadioProps> = ({
  idPrefix,
  label,
  options,
  value,
  onChange,
  error,
  disabled = false,
  className,
}) => (
  <div className={className}>
    <label className="block text-sm leading-5 font-medium text-gray-700 mb-1">
      {label}
    </label>

    <div className="space-y-4 sm:flex sm:items-center sm:space-y-0">
      {options.map((option) => (
        <div key={`${idPrefix}-${option.value}`} className="mr-6">
          <PermissionSection
            permission={disabled ? Permissions.ownership : undefined}
            showPopover
            edit
          >
            <label
              htmlFor={`${idPrefix}-${option.value}`}
              className={classNames(
                'flex items-center',
                disabled ? 'pointer-events-none' : 'cursor-pointer',
              )}
            >
              <input
                id={`${idPrefix}-${option.value}`}
                name={idPrefix}
                type="radio"
                checked={value === option.value}
                onChange={() => onChange(option.value)}
                disabled={disabled}
                className={classNames(
                  'focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300',
                  disabled ? 'bg-gray-100' : 'cursor-pointer',
                )}
              />
              <span className="pl-3 block text-sm font-medium text-gray-700">
                {option.name}
              </span>
            </label>
          </PermissionSection>
        </div>
      ))}
    </div>

    {error && (
      <p className="text-sm leading-4 mt-2 text-red-600">{error.message}</p>
    )}
  </div>
);

export default OwnerRadio;
